declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../src/app/ncs/models/api_response_model';
import { ApiRequestModel } from '../../../src/app/ncs/models/api_request_model';
import { SpinnerService } from '../../../src/app/ncs/services/spinner.service';
import { AppData } from '../../../src/app/ncs/models/appdata';
import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from '@angular/router';
import { xLoginResponse } from '../../../src/app/ncs/models/login/loginresponsemodel';
import { LoginRequest, AppUserSettingRequest, AppUserSettingInfoController } from '../../../src/app/ncs/models/login/loginrequestmodel';
import { NGXToastrService } from '../../../src/app/shared/services/toastr.service';

import { LoginService } from '../../../src/app/ncs/services/login.service';
import { HCPService } from '../../../src/app/ncs/services/hcp.service';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController }
  from '../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { ActorProfileRequest, ActorProfileController, ActorImageController } from '../../../src/app/ncs/models/actor/actor';

import * as alertFunctions from '../../../src/app/shared/data/sweet-alerts';

import sha1Hex from 'sha1-hex';
import MD5 from 'src/app/shared/utils/md5';


import { ThemeService, AppTheme } from '../../../src/app/ncs/services/theme.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'signinpage',
  templateUrl: './signinpage.component.html',
  styleUrls: ['./signinpage.component.scss']
})

export class SignInPageComponent implements OnInit {

  @ViewChild('f') loginForm: NgForm; 
  public logo: string = "Navlogo.png";
  public BgImg: string = "BckgImg.png";
  public logowidth: number;
  public logoheight: number;
  CurrentLoginResponse: xLoginResponse;
  CurrentLoginRequest: LoginRequest;
  public isRequesting: boolean = false;
  public IncialLogin: xLoginResponse
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel;

  CurrentAppUserSettingRequest: AppUserSettingRequest;

  CurrentAppUserSettingInfoController: AppUserSettingInfoController;


  public IncialApiResData: ApiResponseModel


  constructor(
    private loaderService: SpinnerService,
    private tosterservice: NGXToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private loginservice: LoginService,
    private modalService: NgbModal,
    private hcpservice: HCPService,
    public themeService: ThemeService
  ) { }

  get currentTheme(): string {
    return this.themeService.currentTheme;
  }

  get themes(): AppTheme[] {
    return this.themeService.themes;
  }

  selectTheme(themeId: string) {
    this.themeService.setTheme(themeId);
  }
  ngOnInit() {

    if (AppData.Instance().IsSessionExits === true) {

      localStorage.clear();
      AppData.Instance().UserLoginDetails = this.IncialLogin;
      this.ApiResData = this.IncialApiResData;
    }
    this.tosterservice.clearToast();
    this.CurrentLoginResponse = new xLoginResponse();
    this.CurrentLoginRequest = new LoginRequest();

    this.CurrentLoginRequest.RequestMode = 'WEB';
    this.CurrentLoginRequest.RequestType = 1;
    this.CurrentLoginRequest.ClientDate = new Date();
    this.ApiReqData = new ApiRequestModel();
    this.ApiReqData.xRequestType = 1;

    this.CurrentAppUserSettingRequest = new AppUserSettingRequest();
    this.CurrentAppUserSettingInfoController = new AppUserSettingInfoController();
    this.loginservice.xGetSettings().subscribe(v => {
      if (v && v.GlobalApiUrl && !v.GlobalApiUrl.includes('localhost:5000') && !v.GlobalApiUrl.includes('53373')) {
        let apiUrl = v.GlobalApiUrl;
        if (!apiUrl.endsWith('api/')) {
          apiUrl = apiUrl.endsWith('/') ? apiUrl + 'api/' : apiUrl + '/api/';
        }
        AppData.GlobalApiUrl = apiUrl;
      } else {
        AppData.GlobalApiUrl = environment.apiUrl.endsWith('/') ? environment.apiUrl : environment.apiUrl + '/';
      }
      this.logo = v.Navlogo;
      this.BgImg = v.BckgImg;
      this.logowidth = v.HlogoWidth;
      this.logoheight = v.HlogoHeight;
      AppData.Instance().cas = v;
    },

      () => { },
      () => {
        //         this.cas = settings;

      });

  }

   strEncodeUTF16(str:string) {
  var arr = []
     for (var i = 0; i < str.length; i++) {
       arr[i] = str.charCodeAt(i)
  }
  return arr
}
    dec2hex(dec, padding) {
  return parseInt(dec, 10).toString(16).padStart(padding, '0');
}

  utf8StringToUtf16String(str) {
  var utf16 = [];
  for (var i = 0, strLen = str.length; i < strLen; i++) {
    utf16.push(this.dec2hex(str.charCodeAt(i), 4));
  }
  return utf16.join();
}
  onSubmit() {

    if (AppData.Instance().IsSessionExits === true) {

      localStorage.clear();
      AppData.Instance().UserLoginDetails = this.IncialLogin;
      this.ApiResData = this.IncialApiResData;
    }

    if (this.CurrentLoginRequest.UserName != "" && this.CurrentLoginRequest.Password != "") {

      let loginReq: any = Object.assign({}, this.CurrentLoginRequest);
      if (AppData.IsEncriptFromClientSide == true) {
        if (!loginReq.Password.endsWith('=') || loginReq.Password.length !== 24) {
          loginReq.Password = MD5(loginReq.Password);
        }
        loginReq.IsEncriptFromClient = true;
      }
      this.spinner.show();
      this.StartRefreshing();
   
      this.loginservice.xLoginRequest(loginReq)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            AppData.Instance().IsSessionExits = true;

            this.stopRefreshing();
            this.spinner.hide();

            //AppData.Instance().UserLoginDetails = this.ApiResData.Result[0];
            //AppData.ActorImage = AppData.Instance().UserLoginDetails.ActorImageFile;

            const resObj = Array.isArray(this.ApiResData.Result) ? this.ApiResData.Result[0] : this.ApiResData.Result;
            this.CurrentAppUserSettingInfoController = resObj || {};

            AppData.Instance().AppUserSettingInfo = resObj || {};
            const userDetails = (resObj && resObj.xLoginController) ? resObj.xLoginController : (resObj || {});
            AppData.Instance().UserLoginDetails = userDetails;
            AppData.ActorImage = userDetails.ActorImageFile || userDetails.actorImageFile || '';

            localStorage.clear();

            const userName = userDetails.UserName || userDetails.userName || '';
            const authKey = userDetails.AuthGenKEY || userDetails.authGenKEY || '';

            if (userName) {
              localStorage.setItem('UserName', userName);
              this.ApiReqData.xUserName = userName;
              this.ApiReqData.xAuthGenKEY = authKey;
            }

            AppData.Instance().ApiRequestParms = this.ApiReqData;
            this.tosterservice.typesuccess();

            const actorType = userDetails.ActorType ?? userDetails.actorType ?? (this.CurrentAppUserSettingInfoController?.xLoginController?.ActorType);
            const userType = userDetails.UserType ?? userDetails.userType ?? (this.CurrentAppUserSettingInfoController?.xLoginController?.UserType);

            if (actorType == 9 || userType == 9) { // provider / super admin / doctor
              this.FindWhereToGo();
            }
            else if (userType == 3) {
              this.FindWhereToGo();
            }
            else if (userType == 12) {
              this.router.navigate(['sysadmin/sysdashboard']);
            }
            else if (userType == 13 || userType == 14) {
              this.router.navigate(['regadmin/regadmindashboard']);
            }
            else if (userType == 15 || userType == 16) {
              this.router.navigate(['hcare/schedulemanagerh']);
            }
            else if (userType == 1 && actorType == 3) {
              this.FindWhereToGo();
            }
            else if (userName !== '') {
              this.FindWhereToGo();
            }
            else {
              alertFunctions.AlertParamEr('InValid User Account Please Contact Admin...!');
            }



          }
          else {
            this.CurrentLoginRequest.Password = "";
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {
              this.spinner.hide();
              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            }
            else {
              this.spinner.hide();
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }

        },


          (error) => {

            this.CurrentLoginRequest.Password = "";

            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);
              this.spinner.hide();
              this.stopRefreshing();



            }
            else {
              alertFunctions.AlertParamEr(error);
              this.spinner.hide();
              this.stopRefreshing();
            }
          }


        );
    }
    else {
      this.CurrentLoginRequest.Password = "";
      //alertFunctions.AlertParam("InProper Inputs....!");
      alertFunctions.AlertParamEr("Invalid Input entered, please check.");
    }


  }
  CurrentActorPersonalDetailInfoRequest: ActorPersonalDetailInfoRequest;
  CurrentActorPersonalDetailInfoController: ActorPersonalDetailInfoController;

  public ApiResData_profile: ApiResponseModel;
  NurseActorCode: number = 0;
  FindWhereToGo() {
    //this.router.navigate(['healins/newdashboard']);
    this.router.navigate(['branchrole']);
    //alertFunctions.AlertParam("nurse user.. ")
    //this.CurrentActorPersonalDetailInfoRequest = new ActorPersonalDetailInfoRequest();
    //this.CurrentActorPersonalDetailInfoController = new ActorPersonalDetailInfoController();
    //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
    //this.CurrentActorPersonalDetailInfoRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode; //this.CurrentAppUserSettingRequest.ActorCode;
    //this.CurrentActorPersonalDetailInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.GetActorPersonalDetailInfoController();



  }
  GetActorPersonalDetailInfoController() {

    this.StartRefreshing();
    this.hcpservice.GetActorPersonalDetailInfoController(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData_profile = result;
        if (!this.ApiResData_profile.hasError) {


          this.CurrentActorPersonalDetailInfoController = this.ApiResData_profile.Result[0];


          //
          this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
          this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

          this.stopRefreshing();

          if (this.CurrentActorPersonalDetailInfoController.ProfileTitle.length > 0 ||
            this.CurrentActorPersonalDetailInfoController.ProfileSummary.length > 0
          ) {
            this.router.navigate(['nurse/dashboard']);
          }
          else {
            this.router.navigate(['nurse/profile']);
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData_profile.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData_profile.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  // On Forgot password link click
  onForgotPassword() {

    this.router.navigate(['forgotpassword']);


    //this.activeModal.close();
    //let options: NgbModalOptions = {
    //  windowClass: 'center-dialog',
    //  backdrop: 'static',
    //  keyboard: false
    //};
    //const modalRef = this.modalService.open(NgbForgetPWDModal, options)

  }
  // On registration link click
  onRegister() {

    //this.router.navigate(['register']);
  }
  //
  GetAppUserSettingInfoController() {
    this.StartRefreshing();
    this.loginservice.GetAppUserSettingInfoController(this.CurrentAppUserSettingRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentAppUserSettingInfoController = this.ApiResData.Result;
          AppData.Instance().AppUserSettingInfo = this.ApiResData.Result;
          // console.log(';;;;;;;;;;;' + this.CurrentAppUserSettingInfoController.FacilityConfigParamController[0].ConfigParamValue) 
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    //alert(this.loaderService.displayLoader.length);

    this.isRequesting = false;
  }
  private StartRefreshing() {

    this.loaderService.displayLoader(true);
    //alert(this.loaderService.displayLoader.length);
    //alert("hello");
    this.isRequesting = true;
  }





}
